import { createAction, handleActions } from "redux-actions";

const RESET = "RESET";
const GET_WEBSOCKET_MESSAGE_PENDING = "GET_WEBSOCKET_MESSAGE_PENDING";
const UPDATE_WEBSOCKET_MESSAGE = "UPDATE_WEBSOCKET_MESSAGE";
const UPDATE_NOTIFY_STATUS = "UPDATE_NOTIFY_STATUS";
const UPDATE_NEW_MESSAGE = "UPDATE_NEW_MESSAGE";

const initialState = {
    pending: false,
    error: false,
    data: null,
    isFetchMore: false,
    newMessage: false,
};

export default handleActions(
    {
        [RESET]: () => {
            return {
                ...initialState,
            };
        },
        [GET_WEBSOCKET_MESSAGE_PENDING]: (state, action) => {
            const { isFetchMore } = action.payload || {};
            return {
                ...state,
                pending: true,
                isFetchMore: isFetchMore,
            };
        },
        [UPDATE_WEBSOCKET_MESSAGE]: (state, action) => {
            const { type, data, nextToken } = action.payload;
            if (type === "NOTIFY")
                return {
                    ...state,
                    newMessage: data.type === "NEW_MESSAGE",
                };
            else if (type === "MESSAGE_LIST") {
                return {
                    ...state,
                    pending: state.isFetchMore && !!nextToken,
                    data: state.isFetchMore ? [...(state.data ?? []), ...data] : data,
                    isFetchMore: !!nextToken,
                };
            }
            return state;
        },
        [UPDATE_NOTIFY_STATUS]: (state, action) => {
            const { status, targets } = action.payload;

            if (!state.data) {
                return state;
            }

            const updatedList = state.data.map((item) => {
                const isTarget = targets.some(
                    (target) => target.receivedAt === item.receivedAt && target.traceId === item.traceId,
                );

                if (isTarget) {
                    return {
                        ...item,
                        status: status,
                    };
                }
                return item;
            });

            return {
                ...state,
                data: updatedList,
            };
        },
        [UPDATE_NEW_MESSAGE]: (state, action) => {
            return {
                ...state,
                newMessage: action.payload,
            };
        },
    },
    initialState,
);

export const reset = createAction(RESET);
export const getWebsocketMessagePending = createAction(GET_WEBSOCKET_MESSAGE_PENDING);
export const updateWebsocketMessage = createAction(UPDATE_WEBSOCKET_MESSAGE);
export const updateNotifyStatus = createAction(UPDATE_NOTIFY_STATUS);
export const updateNewMessage = createAction(UPDATE_NEW_MESSAGE);
